'use client'

import {useTranslations} from 'next-intl'
import type {Locale, Me} from '@/lib/api/types'
import {ToastProvider} from '../Toast'
import {AppHeader} from './AppHeader'
import {BottomNav} from './BottomNav'
import {SideNav} from './SideNav'
import './shell.css'

/**
 * The chrome every signed-in page renders inside (T-WEB-08).
 *
 * A client component because the header, nav highlighting and toasts are all
 * interactive — but `children` stays a server-rendered subtree, so pages keep
 * their RSC payload and the dashboard's first paint needs no client fetch
 * (T-PERF-01).
 */
export function AppShell({
  me,
  locale,
  children
}: {
  me: Me
  locale: Locale
  children: React.ReactNode
}) {
  const t = useTranslations('shell')

  return (
    <ToastProvider>
      <div className="u-app">
        <a className="u-skip" href="#main">
          {t('skipToContent')}
        </a>
        <AppHeader me={me} locale={locale} />
        <div className="u-app__body">
          <SideNav locale={locale} />
          <main id="main" className="u-app__main" tabIndex={-1}>
            {children}
          </main>
        </div>
        <BottomNav locale={locale} />
      </div>
    </ToastProvider>
  )
}
